<main class="main overflow-hidden" id="app-container" theme>
    <app-toast aria-live="polite" aria-atomic="true"></app-toast>
    <header class="page-header container d-flex justify-content-between align-items-center">
        <img class="qeleo-logo" routerLink="/home" src="assets/images/qeleo-logo.svg">
        <div class="router-link-wrapper d-none d-lg-flex">
            @for(navItem of headerNavArr; track $index){
        <a class="h5-lg text-decoration-none router-link secondary-text d-flex align-items-center"
           routerLink="{{navItem?.link}}"
           routerLinkActive="active">
            {{navItem?.name}}
            @if(navItem.link === '/products'){
            <app-qeleo-icon className="ms-1" iconName="chevron-down-o"></app-qeleo-icon>
            }
        </a>
        }
        </div>
        <button (click)="openContactModal()" class="contact-btn btn rounded-pill btn-lg d-none d-lg-flex">Contact us</button>
        <div class="nav-modal-icon d-lg-none">
            <app-qeleo-icon (click)="openNavModal()" iconName="justify-o" size="xl"></app-qeleo-icon>
        </div>
    </header>
    <router-outlet></router-outlet>
    <footer class="page-footer container d-flex flex-column align-items-center">
        @if(!hideContactUsComponent){
        <app-contact-us></app-contact-us>
        }
        <app-navigation-footer class="w-100"></app-navigation-footer>
    </footer>
</main>

<ng-template #navModalRef let-modal>
    <div class="nav-modal position-relative">
        <button (click)="onClose()"
                class="close-btn btn rounded-circle position-absolute d-flex align-items-center justify-content-center">
            <app-qeleo-icon class="close-icon" iconName="close-o" size="xl"></app-qeleo-icon>
        </button>
        <img (click)="navModal.close()" class="qeleo-logo" routerLink="/home" src="assets/images/qeleo-logo.svg">
        <div class="router-link-wrapper d-flex flex-column">
            @for(navItem of headerNavArr; track $index){
            <a (click)="navModal.close()"
                class="h5-lg z-0 text-decoration-none router-link secondary-text d-flex align-items-center"
                routerLink="{{navItem?.link}}"
               routerLinkActive="active">
            {{navItem?.name}}
            @if(navItem.link === '/products'){
            <app-qeleo-icon className="ms-1" iconName="chevron-down-o"></app-qeleo-icon>
            }
            </a>
            }
        </div>
        <button (click)="openContactModal()" class="contact-btn btn rounded-pill btn-lg w-100">
            Contact us
        </button>
    </div>
</ng-template>
